export * from './events';
export * from './message';
export * from './pagePath';

export const TOKEN = 'token';

export const OPENID_KEY = 'openIdKey';

export const SEARCH_VALUE = 'search_value';

export const SKU_SPLITER = '*';

export const LIMIT = 10;

export const LIMIT_MAX = 99;

export const TIME_OUT = 6000;

/** 新用户的临时分销信息 */
export const NEW_USER_TEMP_SHARE_DISTRIBUTOR = '__NEW_USER__TEMP_SHARE_DISTRIBUTOR___';

/** 自定义页面弹窗缓存 */
export const CUSTOM_PAGE_ACTIVITY_MODAL = '__CUSTOM_PAGE_ACTIVITY_MODAL__';

/** 自定义订阅通知拒绝授权时间 */
export const CUSTOM_NOTICE_REJECTED_RECORD = '__CUSTOM_NOTICE_REJECTED_RECORD__';

/** 微信 H5 SDK 相关 */
export const OFFICIAL_ACCOUNT_CODE_KEY = 'official_account_code';

/** 微信 scene 场景值相关 */
export const WECHAT_SCENE_KEY = 'wechat_scene';
